import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TermsandConditions from "../userAuth/Login/termsandconditions";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

const logo = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const menuItems = ["home", "about_us", "contact_us"];

  const companyItems = ["privacy_policy", "terms_conditions"];
  const [openterms, setOpenterms] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState<"terms" | "privacy">("terms");

  const handleopenterms = (type: "terms" | "privacy") => {
    setModalType(type);
    setModalTitle(
      type === "terms" ? t("terms_conditions") : t("privacy_policy")
    );
    setOpenterms(true);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };

  const handleMenuItemClick = (item: string) => {
    if (item === "home") {
      navigate("/");
    } else if (item === "contact_us") {
      navigate("/contactus");
    } else if (item === "about_us") {
      navigate("/aboutus");
    } else if (item === "services") {
      navigate("/services");
    }

    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top on page loads
  };

  const handleCompanyMenuItemClick = (item: string) => {
    if (item === "privacy_policy") {
      handleopenterms("privacy");
    } else if (item === "terms_conditions") {
      handleopenterms("terms");
    }
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "white", // Blue background like header
          py: 5,
          mt: 0, // No top padding
          color: "black", // All text white
          width: "100vw",
          position: "relative",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid container spacing={1} sx={{ maxWidth: "1800px" }}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  paddingLeft: { xs: 2, lg: 15 },
                }}
              >
                <img
                  src={logo}
                  alt="Clinical Visuals"
                  width={200}
                  height="auto"
                  // style={{ width: 200, height: "auto" }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", lg: "18px" },
                    paddingRight: { xs: "10px" },
                    textAlign: "jusitfy",
                    mt: 2,
                    color: "balck",
                  }}
                >
                  {t("we_specialize_description")}
                  {/* We specialize in creating high-quality 3D medical animations
                  that simplify and clarify complex medical concepts. */}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography
                variant="body2"
                fontWeight="bold"
                gutterBottom
                color="black"
                sx={{
                  fontSize: "20px",
                  textAlign: "left",
                  paddingLeft: { xs: 2, lg: 10 },
                }}
              >
                {t("quick_links")}
              </Typography>
              <List>
                {menuItems.map((text) => (
                  <ListItem
                    key={text}
                    sx={{
                      py: 0.5,
                      cursor: "pointer",
                      paddingLeft: { xs: 2, lg: 10 },
                    }}
                    onClick={() => handleMenuItemClick(text)}
                  >
                    <ListItemText
                      primary={t(text)}
                      primaryTypographyProps={{
                        color: "black",
                        // fontWeight: { lg: "bold" }, // Added bold text
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>

            <Grid item xs={12} md={2}>
              <Typography
                variant="body2"
                fontWeight="bold"
                gutterBottom
                color="balck"
                sx={{ fontSize: "20px", paddingLeft: { xs: 2 } }}
              >
                {t("company")}
              </Typography>
              <List>
                {companyItems.map((text) => (
                  <ListItem
                    key={text}
                    sx={{
                      py: 0.5,
                      cursor: "pointer",
                      paddingLeft: { xs: 2 },
                    }}
                    onClick={() => handleCompanyMenuItemClick(text)}
                  >
                    <ListItemText
                      primary={t(text)}
                      primaryTypographyProps={{
                        color: "#000000",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>

            <Grid item xs={12} md={2}>
              <Typography
                variant="body2"
                fontWeight="bold"
                gutterBottom
                color="balck"
                sx={{
                  fontSize: "20px",
                  paddingLeft: { xs: 2 },
                  fontWeight: 600,
                }}
              >
                {t("contact_info")}
              </Typography>
              <List>
                {[
                  {
                    mail: "contact@clinicalvisuals.com",
                  },
                ].map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      py: 0.5,
                      cursor: "pointer",
                      paddingLeft: { xs: 2 },
                    }}
                  >
                    <ListItemText
                      secondary={
                        <Link
                          href={`mailto:${item.mail}`}
                          underline="hover"
                          color="inherit"
                          sx={{ fontSize: { xs: "17px", md: "17px" } }} // Adjust size as needed
                        >
                          {item.mail}
                        </Link>
                      }
                      primaryTypographyProps={{
                        color: "black",
                        fontWeight: "bold",
                        sx: { fontSize: { xs: "18px", md: "19px" } }, // Make the primary font bigger
                      }}
                      secondaryTypographyProps={{
                        sx: { fontSize: { xs: "16px", md: "18px" } }, // Make the secondary font bigger
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* {/ ==================== SECTION: COPYRIGHT ==================== /} */}
      <Box
        sx={{
          bgcolor: "white", // White background
          display: "flex",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          py: 2,
          borderTop: "1px solid #e0e0e0",
          width: "100vw",
          position: "relative",
          fontSize: "14px",
        }}
      >
        <TermsandConditions
          open={openterms}
          handleCloseTerms={handlecloseterms}
          title={modalTitle}
          type={modalType} // 🔹 Pass 'type' prop (required in API fetch)
        />
        <Typography
          variant="body2"
          sx={{
            flex: 1, // Allows it to take the full width
            textAlign: "center", // Centers the text
            // mr: 25
            paddingRight: { xs: 0, lg: 5 },
          }}
        >
          © Copyrights - All Rights Reserved 2025
        </Typography>
      </Box>
    </>
  );
};
export default Footer;
